import * as React from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import "./FormDialog.css";
import Button from "../Button/Button";
import close from '../../assets/icons/close.svg'
import { Tooltip } from '@mui/material';

export default function FormDialog({ open, handleClose, projectData, setProjectData, handleCreate }) {

    const handleChange = (e, key) => {
        setProjectData(prevData => ({
            ...prevData,
            [key]: e.target.value
        }));
    };
    return (
        <div>
            <Dialog className='custom-dialog' open={open} onClose={handleClose}>
                <DialogTitle className="title-dialog">Add Project
                    <Tooltip title='Close' arrow placement='bottom' >
                        <img
                            tabIndex={0}
                            src={close}
                            onClick={handleClose}
                            onKeyDown={(event) => {
                                if (event.key === "Enter" || event.key === " ") {
                                    event.preventDefault(); // Prevent default behavior (e.g., scrolling)
                                    handleClose(); // Call the handleClose function
                                }
                            }}
                            alt='/'
                            style={{ cursor: "pointer" }} // Add cursor style to indicate interactivity
                        />
                    </Tooltip>

                </DialogTitle>
                <DialogContent style={{ display: 'flex', flexDirection: 'column', gap: '10px' }} className='content-dialog'>
                    <div>
                        <h6 className='mb-0'>Name</h6>
                        <input
                            autoFocus
                            id="name"
                            type="text"
                            value={projectData.name}
                            placeholder='Enter Project Name'
                            className="MuiInputBase-input MuiInput-input inputbox"
                            variant="standard"
                            autoComplete="off"
                            onChange={(e) => handleChange(e, 'name')}
                            />
                    </div>
                    <div>
                        <h6 className='mb-0'>Url</h6>
                        <input
                            id="url"
                            type="text"
                            value={projectData.url}
                            placeholder='Enter URL'
                            className="MuiInputBase-input MuiInput-input inputbox"
                            variant="standard"
                            autoComplete="off"
                            onChange={(e) => handleChange(e, 'url')}
                            />
                    </div>
                    <div style={{ display: 'flex', gap: '20px' }}>
                        <div>
                            <h6 className='mb-0'>Release Title</h6>  
                            <input
                                id="username"
                                type="text"
                                value={projectData.username}  // used the existing username field to save the data of release title(only for ebook)
                                placeholder='Enter release title'
                                className="MuiInputBase-input MuiInput-input inputbox"
                                variant="standard"
                                autoComplete="new-password"
                                spellCheck={false}
                                onChange={(e) => handleChange(e, 'username')}
                            />
                        </div>
                        <div>
                            <h6 className='mb-0'>Publish Date</h6>  
                            <input
                                id="password"
                                type="text"
                                value={projectData.password}  // used the existing password field to save the data of publish date(only for ebook)
                                placeholder='Enter publish date'    
                                className="MuiInputBase-input MuiInput-input inputbox"
                                variant="standard"
                                autoComplete="new-password"  // Disable autocomplete
                                spellCheck="false"
                                onChange={(e) => handleChange(e, 'password')}
                            />
                        </div>
                    </div>

                </DialogContent>
                <DialogActions>
                    <Button
                        className="cancel button-popup"
                        text="Cancel"
                        onClick={handleClose}
                        heading="Cancel"
                    />
                    <Button
                        className="create button-popup"
                        text="Save"
                        onClick={handleCreate}
                        heading="Create"
                        disable={!projectData?.name}
                    />

                </DialogActions>
            </Dialog>
        </div>
    );
}